import { Experiment } from "@amplitude/experiment-js-client";

let experimentClient = null;

export const amplitudeExperiment = {
	/**
	* @returns {import("@amplitude/experiment-js-client").ExperimentClient} The variant
	*/
	initialize(user) {
		const API_KEY = process.env.VUE_APP_AMPLITUDE_EXPERIMENT_DEPLOYMENT_KEY
		if (!API_KEY) return;

		if (!experimentClient) {
			experimentClient = Experiment.initialize(API_KEY);
		}

		if (user) {
			experimentClient.setUser({
				user_id: user.AgentCode,
			});
		}

		return experimentClient;
	},
	/**
	* Fetch the latest experiment configurations from the server
	* @returns {Promise<import("@amplitude/experiment-js-client").ExperimentClient>}
	*/
	fetchExperiments() {
		const API_KEY = process.env.VUE_APP_AMPLITUDE_EXPERIMENT_DEPLOYMENT_KEY
		if (!API_KEY) return;

		if (!experimentClient) {
			this.initialize();
		}
		return experimentClient?.fetch();
	},
	/**
	* Get the variant for a specific flag
	* @param {string} flagKey
	* @returns {import("@amplitude/experiment-js-client").Variant} The variant
	*/
	getVariant(flagKey) {
		const API_KEY = process.env.VUE_APP_AMPLITUDE_EXPERIMENT_DEPLOYMENT_KEY
		if (!API_KEY) return;

		if (!experimentClient) {
			this.initialize();
		}

		return experimentClient?.variant(flagKey);
	},
	/**
	* Get the variant for a specific flag
	* @param {string} flagKey
	* @param {*} defaultValue - Default value to return if the flag is not found
	* @returns {*} The variant value or the default value
	*/
	getVariantValue(flagKey, defaultValue = null) {
		const API_KEY = process.env.VUE_APP_AMPLITUDE_EXPERIMENT_DEPLOYMENT_KEY
		if (!API_KEY) return;

		if (!experimentClient) {
			this.initialize();
		}

		const variant = this.getVariant(flagKey);
		return variant?.value ?? defaultValue;
	},
	/**
	* Track an exposure event for a specific flag or banner
	* @param {string} flagKey
	*/
	trackExposure (flagKey) {
		const API_KEY = process.env.VUE_APP_AMPLITUDE_EXPERIMENT_DEPLOYMENT_KEY
		if (!API_KEY) return;

		if (!experimentClient) {
			this.initialize();
		}

		experimentClient?.exposure(flagKey);
	},
};
